// Malik vekaleti (MALIK_VEKALET_PLAN.md): istemcinin beklediği hesap bağlamı.
//
// Bağlam sunucuda oturumda tutulur ve sekmeler aynı oturumu paylaşır. Bir sekme
// başka malike geçince ya da vekalet iptal edilince diğer sekme eski malikin
// ekranını göstermeye devam eder. Her istek beklenen bağlamı başlıkla bildirir;
// sunucu (auth/vekalet.py BAGLAM_BASLIGI) uyuşmazlıkta veriye dokunmadan 412
// döner, burada yakalanıp bağlam yenilenir.
import axios from "axios";

export const BAGLAM_BASLIGI = "X-Vekalet-Baglami";
const KENDI_BAGLAMI = "kendi";

let beklenenBaglam = null;
let baglamDegisince = null;
let yenilemeSuruyor = null;

/** Oturumdaki kullanıcı değiştiğinde, yeni kullanıcıyla ilk render'dan ÖNCE çağrılmalı. */
export function beklenenBaglamiAyarla(user) {
  if (!user) {
    beklenenBaglam = null;
  } else {
    beklenenBaglam = user.vekalet ? String(user.vekalet.vekalet_id) : KENDI_BAGLAMI;
  }
}

/** 412 alındığında çağrılacak yenileyici (AuthProvider kaydeder). */
export function baglamDegisinceCagir(fn) {
  baglamDegisince = fn;
}

// Başlık yalnız kendi sunucumuza gider: harici servislerde (harita vb.) özel
// başlık CORS ön isteğini düşürür.
function kendiSunucumuzMu(config) {
  const url = `${config.baseURL || ""}${config.url || ""}`;
  return !/^[a-z]+:\/\//i.test(url) || url.startsWith(window.location.origin);
}

function baslikEkle(config) {
  if (beklenenBaglam && kendiSunucumuzMu(config)) {
    config.headers = config.headers || {};
    config.headers[BAGLAM_BASLIGI] = beklenenBaglam;
  }
  return config;
}

function uyusmazligiYakala(error) {
  if (error?.response?.status === 412 && baglamDegisince) {
    // Bir sayfa aynı anda birkaç istek atar; yenileme bir kez yapılır.
    if (!yenilemeSuruyor) {
      yenilemeSuruyor = Promise.resolve(baglamDegisince()).finally(() => {
        yenilemeSuruyor = null;
      });
    }
  }
  return Promise.reject(error);
}

/** Kendi sunucumuza giden her axios örneğine bağlanır. */
export function vekaletBaglaminiBagla(instance) {
  instance.interceptors.request.use(baslikEkle);
  instance.interceptors.response.use(undefined, uyusmazligiYakala);
}

vekaletBaglaminiBagla(axios);
